import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import GalleryPage from "./pages/GalleryPage";
import EventDetailPage from "./pages/EventDetailPage";
import AdminGalleryPage from "./pages/AdminGalleryPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AuthCallback from "./pages/AuthCallback";
import CaseWatchPage from "./pages/CaseWatchPage";
import CaseWatchDetailPage from "./pages/CaseWatchDetailPage";
import AdminCaseWatchPage from "./pages/AdminCaseWatchPage";

function AppRouter() {
  const location = useLocation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id (from Google OAuth redirect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/gallery/:id" element={<EventDetailPage />} />
      <Route path="/case-watch" element={<CaseWatchPage />} />
      <Route path="/case-watch/:id" element={<CaseWatchDetailPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/gallery" element={<AdminGalleryPage />} />
      <Route path="/admin/case-watch" element={<AdminCaseWatchPage />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Toaster 
            position="top-right" 
            richColors 
            toastOptions={{
              style: {
                background: '#1A1A1A',
                color: '#FFFFFF',
                border: '1px solid rgba(201, 166, 70, 0.3)',
              },
            }}
          />
          <AppRouter />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
